import React, { useCallback, useContext } from "react";
import { Route, useNavigate, Routes as Switch } from "react-router-dom";
import AirplayIcon from "@mui/icons-material/Airplay";
import Menu from "../Components/Navbar/Burger";

import { GlobalContext } from "../context/GlobalContext";
import Routes from "./Data/Routes";
import { NavItems } from "../Components/Navbar/NavbarStyles";
import Resolved from "../Components/Navbar/InspectionFlags/ResolvedFlags";
import Main from "../Components/Navbar/Main";
import BreakdownReport from "../Components/Navbar/BreakdownReport/MachinesBreakdownReport";
import DailyLossReport from "../Components/Navbar/DailyLossReport/MachinesDailyLossReport";

export const NavbarSlackView = ({
  currentView,
  views,
  goToPreviousView,
  goToNextView,
}) => {
  const {
    setMachineId,
    setLog,
    setBacktoMenu,
    setIsSlackViewActive,
    setMenuClicked,
    setisNavActive,
    isNavActive,
  } = useContext(GlobalContext);
  const navigate = useNavigate();

  const closeLog = useCallback(() => {
    setMachineId(undefined);
    setLog(false);
    setBacktoMenu(false);
  }, [setBacktoMenu, setLog, setMachineId]);

  const handleClickMenu = () => {
    if (isNavActive) {
      navigate(Routes.Main);
    }
    setisNavActive((current) => !current);
  };

  return (
    <div
      style={{
        height: "6vh",
        backgroundColor: "black",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        position: "fixed",
        width: "100%",
        zIndex: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginLeft: "15px",
          }}
        >
          <span
            style={{
              color: "#FFF",
              fontFamily: "Open Sans",
              fontSize: "19px",
              fontStyle: "normal",
              fontWeight: 800,
              lineHeight: "120%",
              textTransform: "capitalize",
              verticalAlign: "middle",
            }}
          >
            Airvector Maintenance
          </span>
        </div>
      </div>
      <div>
        <Menu handleClick={handleClickMenu} width="40" height="22" />
        <AirplayIcon
          style={{
            color: "white",
            marginTop: "5px",
            marginRight: "15px",
            cursor: "pointer",
          }}
          onClick={() => {
            setIsSlackViewActive(false);
            closeLog();
            goToPreviousView();
            navigate(Routes.Main);
            setMenuClicked(false);
            setisNavActive(false);
          }}
        />
      </div>
      <NavItems className={isNavActive ? "nav-show" : ""}>
        <Switch>
          <Route path="/main" element={<Main />} />
          <Route path="/main/resolved" element={<Resolved />} />
          <Route path="/main/breakdownReport" element={<BreakdownReport />} />
          <Route path="/main/dailyLossReport" element={<DailyLossReport />} />
        </Switch>
      </NavItems>
    </div>
  );
};
